export const DEFAULT_WIDTH = 265
export const DEFAULT_SHAPE = 'rectangular'
export const DEFAULT_THEME = 'outline'
export const DEFAULT_TYPE = 'standard'
export const DEFAULT_LOGO_ALIGNMENT = 'center'
export const DEFAULT_TEXT = 'signup_with'
export const DEFAULT_CONTEXT = 'signup'
